





import Vue from 'vue'

export default Vue.extend({
  name: 'ActiveCellRenderer',

  computed: {
    icon (): string {
      // @ts-ignore
      return this.params.data.isActive ? 'check' : 'clear'
    },

    color (): string {
      // @ts-ignore
      return this.params.data.isActive ? 'check' : 'clear'
    }
  }
})
